import axios from 'axios';
import { API_ENDPOINTS } from '../config/env';
import { AuthTokens, extractAuthPayload } from '../utils/auth';

export type { AuthTokens as RefreshTokenResponse };
export { isTokenExpired, isTokenExpiringSoon } from '../utils/auth';

export interface RefreshTokenRequest {
  token: string;
  name: string;
}

export const refreshToken = async (request: RefreshTokenRequest): Promise<AuthTokens> => {
  const response = await axios.post(API_ENDPOINTS.REFRESH_TOKEN, request, {
    headers: { 'Content-Type': 'application/json' },
  });
  const payload = extractAuthPayload(response.data);
  if (!payload) throw new Error('Invalid refresh token response');
  return payload;
};
